
import BagHappy from "../../../assets/filled/BagHappy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BagHappyIcon({ className, dataTestid = "BagHappyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BagHappy data-testid={dataTestid} className={classes} {...rest} />
  );
}
